
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';

const styles = {
  ...customCheckboxRadioSwitch,
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    '&>div': {
      maxWidth: 50
    },
    "@media (min-width: 600px)": {
      justifyContent: 'flex-end'
    },
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 400,
    marginLeft: 8
  },
  checkInputs: {
    width: '100%'
  },
  contentFooter: {
    marginTop: 24
  },
  pullRight: {
    "@media (min-width: 600px)": {
      float: 'right'
    },
  },
  container: {
    "@media (min-width: 600px)": {
      padding: '2.5em 3.5em 2em'
    },
    "@media (min-width: 768px)": {
      padding: '3.5em 3.5em 2em'
    },
  }
}

export default styles;
